import { createSelector } from 'reselect'
// import { List } from 'immutable'

const efficiencySelector = state => state.get('efficiency')

export const getIsFetching = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyGet.isFetching
    || efficiency.efficiencyLOBGet.isFetching
    || efficiency.efficiencyLOBExport.isFetching
    || efficiency.efficiencyEdit.isFetching
    || efficiency.efficiencySubmit.isFetching
  }
)
export const getEfficiencyData = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyGet
  }
)
export const getEfficiencyLOBData = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyLOBGet
  }
)
export const editEfficiencyData = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyEdit
  }
)
export const submitEfficiencyData = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencySubmit
  }
)
export const exportEfficiencyData = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyLOBExport.url
  }
)
export const isOpenManual = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return efficiency.efficiencyManual.isOpen
  }
)
export const redirectEfficiency = createSelector(
  efficiencySelector,
  efficiencyImmutable => {
    const efficiency = efficiencyImmutable.toJS()
    return ({
      redirect: (efficiency.efficiencyGet.redirect
      || efficiency.efficiencyLOBGet.redirect
      || efficiency.efficiencyLOBExport.redirect
      || efficiency.efficiencyEdit.redirect
      || efficiency.efficiencySubmit.redirect),
      isAuthenticated: (efficiency.efficiencyGet.isAuthenticated
      || efficiency.efficiencyLOBGet.isAuthenticated
      || efficiency.efficiencyLOBExport.isAuthenticated
      || efficiency.efficiencyEdit.isAuthenticated
      || efficiency.efficiencySubmit.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/efficiency-resource/efficiency-resource-selector.js